import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import { Trans } from "react-i18next";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../../../src/environment.js";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { LinkContainer } from "react-router-bootstrap";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const TenantDashboard = () => {
  const [notification, setNotification] = useState([]);
  const [shipments, setShipments] = useState([]);

  let partnerDetails;
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];
  //   alertArray = JSON.parse(localStorage.getItem("alertArray"));
  //   console.log(alertArray);
  //setNotification({ notification: alertArray });

  const deleteHandler = (dataField) => {
    // alert(dataField);
    // delete the device from database
    console.log("deleting");
    console.log(dataField);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        deleteShipment(dataField);
      }
    });
  };

  const deleteShipment = async (dataField) => {
    axios
      .delete(
        environment.dap_url + "shipmentApi/deleteShipment?_id=" + dataField
      )
      .then(async (res) => {
        console.log(res.data);
        MySwal.fire({
          title: <p>Shipment has been deleted!</p>,
          type: "success",
        }).then((result) => {
          partnerDetails = JSON.parse(localStorage.getItem("partnerDetails"));
          getShipments(partnerDetails);
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: (
            <p>{err?.response?.data?.message || "Something went wrong!"}</p>
          ),
          type: "error",
        });
      });
  };

  useEffect(() => {
    partnerDetails = JSON.parse(localStorage.getItem("partnerDetails"));
    console.log(partnerDetails, "aaaaaaaaaaaaaaaaaaa");
    // setInterval(sayHi, 5000);
    // getAlerts();
    getShipments(partnerDetails);
  }, []);

  const getShipments = (partnerDetails) => {
    console.log(partnerDetails, "aaaaaaaaaaaaaaaaaaa");

    axios
      .get(environment.dap_url + "shipmentApi/getAllShipment")
      // .get(
      //   environment.dap_url +
      //     "shipmentApi/getByConsigneeIdWithLogs?consigneeId=63591c4bccf2257f4673e7e2"
      // )
      .then((res) => {
        //setNotification(alertArray);
        console.log(res.data, "1234466");
        let index = 0;
        // res.data.forEach(element => {
        //   if(element.status <= 4 ){
        //     res.data.splice(index)
        //   }
        //   index++;
        // });
        const userData = JSON.parse(localStorage.getItem("user"));
        let fullData = [];
        const sendingShipment = res.data.filter(
          (item) =>
            item.parentId == userData._id &&
            item.isShipmentReturn == false &&
            item.shipmentLogs.length >= 2
        );

        const acceptingShipment = res.data.filter(
          (item) =>
            item.isShipmentReturn == false &&
            item.consigneedetails[0]._id == userData._id &&
            item.docketNo
        );

        fullData = [...sendingShipment, ...acceptingShipment];

        console.log(fullData);
        setShipments(
          fullData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      })
      .catch((err) => {});
  };
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "shipmentUniqueId",
      text: "Shipment ID",
      sort: true,
    },
    {
      dataField: "consigneedetails[0].userFirstName",
      text: "Partner",
      sort: true,
    },
    {
      dataField: "consignordetails[0].userFirstName",
      text: "Consignor",
      sort: true,
    },
    {
      dataField: "consignmentState",
      text: "State",
      sort: true,
    },
    {
      dataField: "consignmentCountry",
      text: "Country",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,

      formatter: (dataField) => {
        return (
          <div>
            {dataField == 0 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{ backgroundColor: "#6867AC" }}
              >
                Initalized
              </button>
            ) : dataField == 1 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#59a9eb",
                  borderColor: "#59a9eb",
                }}
              >
                Finalized
              </button>
            ) : dataField == 5 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                In - Transit
              </button>
            ) : dataField == 3 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                Approved
              </button>
            ) : dataField == 4 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                Rejected
              </button>
            ) : dataField == 6 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                shipment received
              </button>
            ) : dataField == 7 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All Boxes Received
              </button>
            ) : dataField == 8 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All device Installed
              </button>
            ) : (
              ""
            )}
            {/* {(() => {
              switch (dataField) {
                case 0:
                  return "Initialized";
                case 1:
                  return "Finalized";
                case 3:
                  return "Approved";
                case 4:
                  return "Rejected";
                case 5:
                  return "In Transit";
                case 6:
                  return "shipment received";
                case 7:
                  return "All boxes Received";
                case 8:
                  return "All device Installed";
                default:
                  return "";
              }
            })()} */}
          </div>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        return formatDate(dataField);
      },
    },
    {
      dataField: "docketNo",
      text: "Docket No.",
      sort: true,
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        var disable = false;
        shipments.every((element) => {
          if (element._id == dataField && element.status >= 1) {
            disable = true;
            return false;
          } else {
            disable = false;
            return true;
          }
        });
        return (
          <div>
            <LinkContainer
              to={"/shipmentDetails/" + dataField}
              style={{
                float: "center",
              }}
            >
              <Button variant="light" className="btn-sm">
                <i className="fa fa-eye"></i>
              </Button>
            </LinkContainer>
            {/* <LinkContainer
              to={"partnershipment/edit/" + dataField}
              style={{
                float: "center",
              }}
            >
              <Button variant="info" className="btn-sm" disabled={disable}>
                <i className="fa fa-edit"></i>
              </Button>
            </LinkContainer>
            <Button
              variant="danger"
              className="btn-sm"
              disabled={disable}
              onClick={() => deleteHandler(dataField)}
            >
              <i className="fa fa-trash"></i>
            </Button> */}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">REGULAR SHIPMENTS</h4>
        <ToolkitProvider
          keyField="id"
          bootstrap4
          data={shipments}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex align-items-center">
                <p className="mb-2 mr-2">Search in table:</p>
                <SearchBar {...props.searchProps} />
              </div>
              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={paginationFactory()}
                {...props.baseProps}
                wrapperClasses="table-responsive"
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default TenantDashboard;
